// extracted by mini-css-extract-plugin
module.exports = {"btn":"_25CkNyWMB14GZY3Js2JdF3","icon":"_2AzBpCrI-eW7F0Qqb4RpBA"};